import { ReactNode } from 'react'

import { CLICK_CODE } from '@local/utils'

import { ClickEvent } from '@web/types'
import { BookingPrimitive } from '@web/ui/pages/home/components/Sections/UIDailyBriefingSection/DailyBriefingSection.type'

import { Section, SectionHeader, SectionContent } from '../Section'
import CurrentLocation from './components/CurrentLocation'
import DailyBriefingTab from './components/DailyBriefingTab'
import DailyBriefingTitle from './components/DailyBriefingTitle'
import {
  DirectionsDailyLocation,
  PrimitiveCarDirection,
  PrimitivePublicTransitDirection,
  UsedDailyLocation,
} from './components/DailyLocation'
import DailyWeather, { NowWeather } from './components/DailyWeather'
import styles from './DailyBriefingSection.module.scss'

interface Props {
  focusedBooking: BookingPrimitive
  todayBookings: BookingPrimitive[]
  nowWeather?: NowWeather
  total: number
  handleClickBooking: (bookingId: string) => void
  handleClickPhone: () => void
  onClickRefresh?: () => void
  onClickReviewWrite: (e: ClickEvent) => void
  onClickFindFastestPath: (directionLandingUrl: { appScheme?: string | null; webUrl?: string | null }) => void
  currentAddressLoading?: boolean
  currentAddressName?: string
  directions: {
    car: PrimitiveCarDirection
    publicTransit: PrimitivePublicTransitDirection
  } | null
  directionsLoading: boolean
  visitId: string | null
  children?: ReactNode
  isAvailableBookmark?: boolean
  isBookmarked?: boolean
  openBookmarkModal?: () => void
}

export default function UIDailyBriefingSection({
  total,
  todayBookings,
  focusedBooking,
  nowWeather,
  handleClickBooking,
  handleClickPhone,
  currentAddressName,
  currentAddressLoading,
  onClickRefresh,
  onClickReviewWrite,
  onClickFindFastestPath,
  visitId,
  directions,
  directionsLoading,
  children: DynamicMap,
  isAvailableBookmark,
  isBookmarked,
  openBookmarkModal,
}: Props) {
  return (
    <Section noMargin className={styles.daily_briefing_section}>
      <SectionHeader title="오늘 예약이에요!" />
      <SectionContent>
        {/* 당일 예약건 탭 */}
        {total > 1 && (
          <DailyBriefingTab
            focusedBooking={focusedBooking}
            handleClickBooking={handleClickBooking}
            todayBookings={todayBookings}
          />
        )}

        {/* 방문 카드 */}
        {focusedBooking.placeSummary && (
          <div className={styles.daily_briefing_area}>
            {/* 타이틀 영역 */}
            <DailyBriefingTitle
              booking={focusedBooking}
              bookingDateTime={focusedBooking.formattedBookingDateText}
              handleClickPhone={handleClickPhone}
              isAvailableBookmark={isAvailableBookmark}
              isBookmarked={isBookmarked}
              openBookmarkModal={openBookmarkModal}
            />

            {/* 지도 영역 */}
            {DynamicMap}

            {/* 날씨정보 영역 */}
            <DailyWeather weather={nowWeather} />

            {/* 길찾기정보 영역 */}
            {focusedBooking.isCompleted && visitId ? (
              <UsedDailyLocation onClickUsedCard={onClickReviewWrite} isLoading={false} />
            ) : (
              <DirectionsDailyLocation
                onClickFindFastestCarPath={() =>
                  onClickFindFastestPath(focusedBooking.placeSummary?.directionLandingUrl.car)
                }
                onClickFindFastestPublicTransitPath={() =>
                  onClickFindFastestPath(focusedBooking.placeSummary?.directionLandingUrl.publicTransit)
                }
                directions={directions}
                isLoading={currentAddressLoading || directionsLoading}
              />
            )}
          </div>
        )}
        {/* 현위치 영역 */}
        <CurrentLocation
          currentAddressName={currentAddressName}
          currentAddressLoading={currentAddressLoading}
          onClickRefresh={onClickRefresh}
          clickCode={CLICK_CODE['mydaily.reload']}
        />
      </SectionContent>
    </Section>
  )
}
